import nawatechLogo from "./assets/nawatech-logo.png"

const NotFoundPage = () => {
    return (
        <div className="not-found-container">
            <img src={nawatechLogo} style={{height:"60px"}}/>
            <div>Page not found | 404</div> 
        </div>
    )
}

export default NotFoundPage